// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lfcjprdrjxxmbsqqzzzp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxmY2pwcmRyanh4bWJzcXF6enpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0NTM2MDUsImV4cCI6MjA3MDAyOTYwNX0.kNvB_s0XGUztu_A_Kawup4TtwfvfCVZrRbQs4TGR88w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});